import getAxiosInstance from '../../helpers/get_axios_instance'
import lrsAdapter from '../../helpers/lrs_adapter'
import { OK } from 'http-status-codes'

class MovimientoMercaderia {
  static getMovimientosMercaderia (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const orden = '"orden": ["fecha_de_inicio"]'
    const promise = axios.get(`/consulta_movimiento_mercaderia_en_toneladas?r=` +
    `{"clave":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}, ${orden}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getTareasMovimientoPendientes () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/movimiento_mercaderia_en_toneladas_pendiente`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getTareasMovimiento () {
    const axios = getAxiosInstance()
    const promise = axios.get(`/tarea_movimiento`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data)
  }

  static getTotalMovimientosMercaderia (fechaD, fechaH) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/total_movimiento_mercaderia?r=` +
    `{"parametros":{"fecha_desde": "${fechaD}", "fecha_hasta": "${fechaH}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }

  static submitTareaMovimientoMercaderia (fInicio, fFin, tarea, toneladas) {
    const axios = getAxiosInstance()
    const promise = axios.post(`/movimiento_mercaderia_en_toneladas`,
      `{"valores":{"fecha_de_inicio": "${fInicio}", "fecha_de_finalizacion": "${fFin}", "tarea": "${tarea}", "toneladas": "${toneladas}"}}`)
    return promise.then(lrsAdapter)
  }

  static submitTareaMovimientoMercaderiaPendiente (fInicio, tarea) {
    const axios = getAxiosInstance()
    const promise = axios.post(`/movimiento_mercaderia_en_toneladas`,
      `{"valores":{"fecha_de_inicio": "${fInicio}", "tarea": "${tarea}"}}`)
    return promise.then(lrsAdapter)
  }

  static deleteTareaMovimientoMercaderia (fechaRegistroTarea) {
    const axios = getAxiosInstance()
    const promise = axios.delete(`/movimiento_mercaderia_en_toneladas_pendiente?r=` +
    `{"clave":{"fecha_registro_tarea": "${fechaRegistroTarea}"}}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('Error.')
      return data
    })
  }

  static getTareaMovimientoPorFecha (fechaRegistroTarea) {
    const axios = getAxiosInstance()
    const promise = axios.get(`/movimiento_mercaderia_en_toneladas?r=` +
    `{"clave":{"fecha_registro_tarea": "${fechaRegistroTarea}"}}`)
    return promise.then(lrsAdapter)
      .catch(lrsAdapter)
      .then(result => result.data[0])
  }
}

export default MovimientoMercaderia

// // import { OK } from 'http-status-codes'
// // import getAxiosInstance from '../../helpers/get_axios_instance'

// // Llamada al server de Hugo
// class Movimiento {
//   static async getMovimiento () {
//     const result = {
//       data: [
//         {
//           nombreDeSilo: 'Silo1',
//           cereal: 'cereal 1',
//           sector: 'sector 1',
//           metrosVacio: 'metros 1',
//           fechaInicioLlenado: 'fecha inicio 1',
//           posx: '-31.6',
//           posy: '0.75',
//           posz: '0.0'
//         },
//         {
//           nombreDeSilo: 'Silo2',
//           cereal: 'cereal 2',
//           sector: 'sector 2',
//           metrosVacio: 'metros 2',
//           fechaInicioLlenado: 'fecha inicio 2',
//           posx: '-30.6',
//           posy: '0.75',
//           posz: '0.0'
//         },
//         {
//           nombreDeSilo: 'Silo3',
//           cereal: 'cereal 3',
//           sector: 'sector 3',
//           metrosVacio: 'metros 3',
//           fechaInicioLlenado: 'fecha inicio 3',
//           posx: '-29.6',
//           posy: '0.75',
//           posz: '0.0'
//         },
//         {
//           nombreDeSilo: 'Silo4',
//           cereal: 'cereal 4',
//           sector: 'sector 4',
//           metrosVacio: 'metros 4',
//           fechaInicioLlenado: 'fecha inicio 4',
//           posx: '-28.6',
//           posy: '0.75',
//           posz: '0.0'
//         }

//       ]
//     }
//     return Promise.resolve(result)
//     // const axios = getAxiosInstance()
//     // const promise = axios.get(`/cdmd_movimiento_silo`)
//     // return promise.then((result) => {
//     //   const { status, data } = result
//     //   if (status !== OK) throw new Error('No se pudo obtener el listado.')
//     //   return data
//     // })
//   }
// }

// export default Movimiento
